import { AsyncThunkAction } from 'actions/actions.types'
import { AppDispatchNext } from 'actions/actions.typesNext'
import {
  promoPositions,
  RatingPromo,
} from 'components/page/PhotoRating/PhotoRating.constants'
import { findRandomItem } from 'functions/array'

import { checkFeaturedPhotosActiveAction } from './checkFeaturedPhotosActiveAction'
import { getAvailablePromoTypes, selectPromoType } from './function/promo'

export const SAVE_PROMO = 'SAVE_PROMO' as const

export const preparePromoRatingAction =
  (changePromoForce?: boolean) => async (dispatch: AppDispatchNext) => {
    await dispatch(checkFeaturedPhotosActiveAction())

    dispatch(createPromoAction(changePromoForce))
  }

export const createPromoAction =
  (changePromoForce?: boolean): AsyncThunkAction =>
  (dispatch, getState) => {
    const {
      photoRatingNext: { promo },
      bannerReducer: { directAdFox, enabled },
      photoRatingReducer: { featuredPhotosActive },
    } = getState()

    /**
     * 1. Чтобы не пересоздавать промо которое уже есть в store
     * 2. changePromoForce изменить промо
     * 3. Если купили показы а баннер featured
     */
    if (
      !promo ||
      changePromoForce ||
      (featuredPhotosActive && promo === RatingPromo.featured)
    ) {
      const promoIndex = findRandomItem(promoPositions)
      const promoType = selectPromoType(
        getAvailablePromoTypes(featuredPhotosActive, enabled, directAdFox),
        promo
      )

      return dispatch(savePromoAction(promoIndex, promoType))
    }
  }

export const savePromoAction = (
  promoIndex: number,
  promoType: RatingPromo | null
) => ({
  type: SAVE_PROMO,
  promoIndex,
  promoType,
})

export const INCOGNITO_SAVE_POSITION = 'INCOGNITO_SAVE_POSITION' as const

export const incognitoSavePositionAction = () => ({
  type: INCOGNITO_SAVE_POSITION,
})

export const PROMO_INCREASE_VOTED_COUNTER =
  'PROMO_INCREASE_VOTED_COUNTER' as const

export const promoIncreaseVotedCounter = () => ({
  type: PROMO_INCREASE_VOTED_COUNTER,
})
